<template>
  <button
    ref="buttonRef"
    :class="
      cn(
        'group relative w-full cursor-pointer overflow-hidden rounded-full p-2 px-6 text-center font-semibold',
        props.class,
      )
    "
  >
    <div class="flex items-center gap-2">
      <div
        :class="cn('size-2 scale-100 rounded-lg transition-all duration-300 group-hover:scale-[100.8]', bgColorClass)"
      ></div>
      <span
        :class="cn('inline-block whitespace-nowrap transition-all duration-300 group-hover:translate-x-12 group-hover:opacity-0', textColorClass)"
      >
        {{ text }}
      </span>
    </div>

    <div
      class="absolute top-0 z-10 flex size-full translate-x-12 items-center justify-center gap-2 text-white opacity-0 transition-all duration-300 group-hover:-translate-x-5 group-hover:opacity-100"
    >
      <span class="whitespace-nowrap">{{ text }}</span>
      <Icon name="material-symbols:arrow-right-alt-rounded" class="w-4 h-4"/>
      <!-- <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lucide lucide-arrow-right transform scale-0.5"
      >
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
      </svg> -->
    </div>
  </button>
</template>

<script lang="ts" setup>
import { cn } from '@/lib/utils';
import { ref, computed } from 'vue';

interface Props {
  text?: string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  text: 'Button',
  color: 'emerald',
});

const colorMap = {
  emerald: {
    bg: 'bg-emerald-400',
    text: 'text-emerald-400'
  },
  blue: {
    bg: 'bg-blue-800',
    text: 'text-blue-800'
  },
  red: {
    bg: 'bg-red-400',
    text: 'text-red-400'
  },
  amber: {
    bg: 'bg-amber-400',
    text: 'text-amber-400'
  },
  purple: {
    bg: 'bg-purple-400',
    text: 'text-purple-400'
  },
  pink: {
    bg: 'bg-pink-400',
    text: 'text-pink-400'
  }
};

const bgColorClass = computed(() => {
  return colorMap[props.color.split('-')[0]]?.bg;
});

const textColorClass = computed(() => {
  return colorMap[props.color.split('-')[0]]?.text;
});

const buttonRef = ref<HTMLButtonElement>();
</script>

<style></style>
